import React, { useEffect } from "react"

import {
  WOW_MONEY_NOTIFICATION_CLOSE_DELAY,
  WOW_MONEY_UNIT_PRICE,
  WowMoneyNotification,
} from "live/constants"

interface Props {
  notification: WowMoneyNotification
  onClose: () => void
}

const Notification = ({ notification, onClose }: Props) => {
  const { type, price, message } = notification

  useEffect(() => {
    const timer = setTimeout(onClose, WOW_MONEY_NOTIFICATION_CLOSE_DELAY[type])

    return () => {
      clearTimeout(timer)
    }
  }, [type, onClose])

  const renderMessage = () => {
    // 서버가 사유를 내려줬으면 기본 문구보다 그게 정확하다
    if (message) return <>{message}</>

    switch (type) {
      case "ACCUMULATE":
        return (
          <>
            와우머니{" "}
            <strong className="wmPoint">
              {(price ?? WOW_MONEY_UNIT_PRICE).toLocaleString()}
            </strong>
            원 적립 완료!
          </>
        )
      case "COMPLETE":
      default:
        return <>이번 달 와우머니 적립이 모두 완료됐어요!</>
    }
  }

  return (
    <div
      className="wmNoti" role="status">
      <p>{renderMessage()}</p>
      <button type="button" className="wmNotiClose" onClick={onClose}>
        <span>닫기</span>
      </button>
    </div>
  )
}

export default Notification
